import React, { Component, PropTypes } from 'react'

import Header from './header'

export default class Document extends Component {
    static propTypes = {
        docs: PropTypes.object.isRequired,
        docsActions: PropTypes.shape({
            loadDoc: PropTypes.func.isRequired,
        }).isRequired,
        route: PropTypes.shape({
            slug: PropTypes.string.isRequired,
        }).isRequired,
    }

    componentWillMount() {
        if (! (this.props.route.slug in this.props.docs)) {
            this.props.docsActions.loadDoc(this.props.route.slug)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (! (nextProps.route.slug in nextProps.docs)) {
            nextProps.docsActions.loadDoc(nextProps.route.slug)
        }
    }

    render() {
        if (! (this.props.route.slug in this.props.docs)) {
            return null
        }

        return (
            <div>
                <Header title={ this.props.docs[this.props.route.slug].title } />

                <div className="content">
                    <div
                        className="content__inner"
                        dangerouslySetInnerHTML={{ __html: this.props.docs[this.props.route.slug].body }}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/document.js